<template>
  <div
    class="absolute z-10 w-full h-full flex items-center justify-center"
    :class="textColor + ' ' + bgColor"
  >
    <loading :label="label" text-color="textColor" :size="size"></loading>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      required: false,
    },
    opacity: {
      required: false,
      default: 80,
    },
    textColor: {
      required: false,
      default: "text-full-white",
    },
    size: {
      type: String,
      required: false,
      default: "text-3xl",
    },
  },
  computed: {
    bgColor() {
      // Prevent purceCss to remove thoses classes
      "bg-blacko-10 bg-blacko-20 bg-blacko-30 bg-blacko-40 bg-blacko-50 bg-blacko-60 bg-blacko-70 bg-blacko-80 bg-blacko-90";

      return this.opacity == 0 ? "bg-white" : "bg-blacko-" + this.opacity;
    },
  },
};
</script>
